<template>
  <div class="home-container">
    <!-- <quick-link/> -->
    <Quick @itemClick="itemClick" :cmsConfig="cmsConfig"/>
    <a-row
      class="home-row"
      v-for="(row, rowIndex) in homeComponents"
      :key="rowIndex">
      <a-col
        class="home-col"
        :span="col.span"
        v-for="(col, colIndex) in row"
        :key="colIndex">
        <component :is="col.component" :style="col.height ? { height: col.height } : {}" @itemClick="itemClick" @setMainContent="setMainContent"></component>
      </a-col>
    </a-row>

    <ModalManage @menuChange="menuChange" />
  </div>

</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { Row, Col } from 'ant-design-vue'
  import Quick from './components/quick'
  // import mixins from '@/mixins/mixins'
  // import QuickLink from "./components/quick-link";
  // 工作台新首页组件
  import NewAnnounce from '../common/announceInfo/newAnnounce'
  import NewStoreWarning from './components/newHome/newSotreWarning'
  import NewStoreInfo from './components/newHome/newStoreInfo'
  import Banner from '../common/banner'
  import ModalManage from '../common/modal-manage'
  import MarketingTool from '../common/marketingTool'
  import NewTrainingCenter from './components/newHome/newTrainingCenter'
  import NewStoreData from './components/newHome/newStoreData'
  import NewMarketingActivity from './components/newHome/newMarketingActivity'

  export default {
    name: "home-pop",
    components: {
      // QuickLink,
      Quick,
      [Row.name]: Row,
      [Col.name]: Col,
      NewAnnounce,
      NewStoreWarning,
      NewStoreInfo,
      ModalManage,
      MarketingTool,
      NewTrainingCenter,
      NewStoreData,
      NewMarketingActivity,
    },
    // mixins: [mixins],
    data() {
      return {
        homeComponents: [],
        visible: true,
        tripartiteVisible: false,
        honourVisible: false
      }
    },
    async created() {
      // TODO:
      // this.$store.dispatch('queryIsNeedStamp')
      // 初始化查询菜单数据
      this.$store.dispatch('queryTreeData')
      await this.getBusinessInfo()
      this.isShowUggSell()
    },
    computed: {
      ...mapState(['cmsConfig', 'isUggSell', 'businessInfo', 'homeAnnouncementList']),
      showConfirmModal() {
        // return true
        return this.visible && this.$store.state.showConfirmModal
      }
    },
    methods: {
      ...mapActions(['getBusinessInfo']),
      ...mapActions('popHome',[
        'setHonourFlag'
      ]),
      setMainContent(component) {
        this.$emit('setMainContent', component)
      },
      itemClick (link) {
        this.$emit('itemClick', link)
      },
      menuChange(item) {
        this.$emit('menuChange', item)
      },
      // 全球购经销首页做区分
      isShowUggSell() {
        if (this.isUggSell) {
          this.homeComponents = [
            [
              {
                span: 24,
                component: NewStoreInfo,
                height: `80px`
              },
              {
                span: 24,
                component: NewStoreWarning,
                height:'100vh'
              }
            ]
          ]
        } else {
          this.homeComponents = [
            [
              {
                span:24,
                component: NewAnnounce,
                height:`50px`
              },
              {
                span: 14,
                component: NewStoreWarning,
                height: `500px`
              },
              {
                span: 10,
                component: NewStoreInfo,
                height: `500px`
              }
            ],
            [
              {
                span: 14,
                component: NewStoreData,
                height: `450px`
              },
              {
                span: 10,
                component: NewMarketingActivity,
                height: `450px`
              }
            ],
            [
              {
                span: 14,
                component: MarketingTool,
                height: `510px`
              },
              {
                span: 10,
                component: NewTrainingCenter,
                height: `510px`
              }
            ]
          ]
          // 是否显示轮播图
          if (this.cmsConfig.banner.length > 0) {
            this.homeComponents.splice(2, 0, [
              {
                span:24,
                component: Banner,
                height:`70px`
              }
            ])
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.home-container {
  width: 100%;
  height: 100%;
}
.home-row {
  margin: -8px;
  .home-col {
    padding: 8px;
  }
}
</style>
